var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.584,
    height: 151.023,
    viewBox: "0 0 184.584 151.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-featured-play-list",
    "data-name": "Icon material-featured-play-list",
    d: "M169.3,4.5H18.28A16.83,16.83,0,0,0,1.5,21.28V138.743a16.83,16.83,0,0,0,16.78,16.78H169.3a16.83,16.83,0,0,0,16.78-16.78V21.28A16.83,16.83,0,0,0,169.3,4.5ZM93.792,71.622H18.28V54.841H93.792Zm0-33.561H18.28V21.28H93.792Z",
    transform: "translate(-1.5 -4.5)",
    fill: "#08cd34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetBlue);
export default __webpack_public_path__ + "static/media/bet-blue.8af88a097aea67fe586f5aca5a641608.svg";
export { ForwardRef as ReactComponent };